/**
 * Press archive filter — vanilla JS, progressive enhancement only.
 * All rows are rendered server-side by Liquid; this script just toggles
 * the `hidden` attribute. If this file fails to load, the full archive
 * still renders and is fully crawlable/indexable.
 *
 * State: query (search box) + year (active pill). Both combine with AND.
 * Search matches against the `data-search` attribute (title + source,
 * already lowercased server-side). Year matches the `data-year` attribute
 * exactly, or shows everything when the "All" pill is active.
 */
(function () {
  var table = document.getElementById('press-archive-table');
  if (!table) return;

  var searchInput = document.getElementById('press-search-input');
  var pillsWrap = document.getElementById('press-year-pills');
  var emptyState = document.getElementById('press-archive-empty');
  var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));

  var state = { query: '', year: 'All' };

  function applyFilters() {
    var query = state.query.trim().toLowerCase();
    var visibleCount = 0;

    rows.forEach(function (row) {
      var matchesQuery = !query || (row.getAttribute('data-search') || '').indexOf(query) !== -1;
      var matchesYear = state.year === 'All' || row.getAttribute('data-year') === state.year;
      var isVisible = matchesQuery && matchesYear;
      row.hidden = !isVisible;
      if (isVisible) visibleCount++;
    });

    if (emptyState) {
      emptyState.hidden = visibleCount !== 0;
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', function (e) {
      state.query = e.target.value;
      applyFilters();
    });
  }

  if (pillsWrap) {
    var pills = Array.prototype.slice.call(pillsWrap.querySelectorAll('.press-pill'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        state.year = pill.getAttribute('data-year');
        pills.forEach(function (p) {
          var isActive = p === pill;
          p.classList.toggle('is-active', isActive);
          p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        applyFilters();
      });
    });
  }
})();
